import { useEffect } from 'react';
import { Routes, useNavigate } from 'react-router-dom';

// IMPORT ROUTE
import Login from 'routes/auth/Login';

import ROUTES, { routesSettings } from 'constants/routes';

import getRoute from 'components/core/RouteWithSubRoutes';

const routeConfig = Object.freeze({
  [ROUTES.AUTH_LOGIN]: {
    element: <Login />,
    path: routesSettings.AUTH_LOGIN.path,
  },
});

const AuthRoutes = (): JSX.Element => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(routeConfig[ROUTES.AUTH_LOGIN].path, { replace: true });
  }, []);

  return (
    <>
      <Routes>
        {Object.entries(routeConfig).map(([key, val]) => getRoute(val))}
      </Routes>
    </>
  );
};

export default AuthRoutes;
